export default __webpack_public_path__ + "static/media/search.ffd2236a.svg";